export default {
  computed: {
    isChromeAndroid: function () {
      let ua = window.navigator.userAgent
      return /Chrome/i.test(ua) && /Android/i.test(ua)
    },
  },
}
